function BlogSection() {
  const posts = [
    {
      date: "17 Jul 2026",
      title: "laner.gg: Team vs Team matchup informational research",
      content:
        "Currently researching the requirements for accurate and effective understanding of team compositions whilst waiting for the riot API prod key",
    },
    {
      date: "12 Jul 2026",
      title: "laner.gg: Custom pixel art favicon",
      content:
        "Hand-drawn pixel art favicon replacing the default icon, a shooting star forming the L, built in Aseprite on a 64x64 grid and exported at 16x16, 32x32 and 180x180 for browser tab, bookmark and iOS home screen icons.",
    },
    {
      date: "08 Jul 2026",
      title: "laner.gg: SEO infrastructure, sitemap, robots.txt, indexing",
      content:
        "Built dynamic sitemap.xml and robots.txt endpoints generated live from the DB, covering the homepage and all champion and matchup pages. Found and fixed a Netlify redirects catch-all that was silently overriding the backend proxy rules for both routes. Added a Cloudflare verified-bot allowlist so Googlebot could actually fetch the sitemap through the existing anti-scraping layer. Submitted to Google Search Console, homepage indexed within an hour, 499 pages discovered via sitemap. Added a proper og:image so links shared on Discord, Twitter and Reddit show a real preview instead of a blank card.",
    },
    {
      date: "14 Jun 2026",
      title: "laner.gg: Riot API production key application and legal pages",
      content:
        "Terms of Service and Privacy Policy pages built and shipped, Riot Games disclaimer added site-wide, domain verification file live at riot.txt. Submitted production API key application for League-v4, Match-v5, Summoner-v4, Account-v4 and Champion Mastery v4, under a dedicated service account separated from personal Riot account. Vendor names for hosting, CDN and DB providers deliberately excluded from the public Privacy Policy, categories disclosed instead.",
    },
    {
      date: "14 Jun 2026",
      title: "laner.gg: Champion page full redesign",
      content:
        "Rebuilt around a two tab layout. Overview surfaces win condition, ability icon row with hover video previews, strengths and weaknesses, and a colour coded power curve timeline. Details holds kit nuances, trading pattern, key cooldowns and combos behind collapsibles. Pentagon radar computed from profile data replaces the old raw stat bar list in the sidebar. Cut duplicate content that was repeating the same facts across three different sections.",
    },
    {
      date: "13 Jun 2026",
      title: "laner.gg: Landing page starfield",
      content:
        "CSS based star field on the landing page, 95 twinkling stars across 3 colour variants plus rare randomly positioned shooting stars with glowing comet heads. Replaced an earlier canvas based attempt after it caused a blank page render bug.",
    },
    {
      date: "12 Jun 2026",
      title: "laner.gg: SEO hooks and derived matchup placeholders",
      content:
        "useSEO hook rolled out across every page for dynamic title, meta description and Open Graph tags. Built DerivedMatchup, for the roughly 6,500 champion pairings without a generated AI matchup yet, assembles a real analysis on the fly from both champions profiles instead of showing a dead page.",
    },
    {
      date: "07 Jun 2026",
      title: "laner.gg: 172 champion profiles seeded plus API hardening",
      content:
        "Generated full strategic profiles for all 172 champions, win condition, power curve, kit nuances, combos, trading pattern, key cooldowns, team role and synergies, damage type, lane phase strength, using Sonnet with exact cooldown and range data injected from Data Dragon. Seeded locally, verified, then pushed to NeonDB via a Python export and import pipeline. Added slowapi rate limiting per endpoint, GET only CORS, and zero width character watermarking on AI generated text.",
    },
    {
      date: "04 Jun 2026",
      title: "laner.gg: Frontend refactor and condensed champion UI",
      content:
        "Extracted shared utilities and matchup UI components out of monolithic page files. MatchupCard cut from 700 plus lines to around 250. Champion page layout condensed for information density.",
    },
    {
      date: "03 Jun 2026",
      title: "laner.gg: Ability hover video and routing fixes",
      content:
        "Fixed ability icon hover video, needed the champion numeric Data Dragon key which the champion list endpoint does not return. Fixed Netlify SPA routing so direct URL loads and refreshes on champion and matchup pages no longer 404.",
    },
    {
      date: "02 Jun 2026",
      title: "laner.gg: Matchup content accuracy pass and schema update",
      content:
        "Added AI generated content columns to the matchup table and wired up the content endpoint. Fixed inaccurate Darius vs Garen matchup data and stripped stray source note text leaking into generated content. Added missing httpx dependency for backend AI calls.",
    },
    {
      date: "31 May 2026",
      title: "laner.gg: On-demand content generation + matchup logic overhaul",
      content:
        "Replaced keyword text scanning with whitelists for CC, sustain, stealth and shields per champion. CC counts now accurate, false triggers removed for Zed, Veigar, Syndra. Trade verdict now uses stat comparisons. Power spikes hardcoded per champion for top 40 with Nasus getting stack milestones and Malphite flagging pre-6 weakness.",
    },
    {
      date: "31 May 2026",
      title: "laner.gg: Landing page polish + matchup page UX overhaul",
      content:
        "Bigger logo, full-page ambient particles on landing. Sidebar removed from matchup page, champion selects now inline in a sticky top bar. Bottom nav stays visible while scrolling. Removed dead files: App.jsx, LandingView.jsx, RangeVisualiser.jsx.",
    },
    {
      date: "31 May 2026",
      title: "laner.gg: Full width content layout",
      content:
        "Replaced 280px sidebar with a 58px sticky top bar containing both champion search inputs, VS divider, compare button, tabs and patch badge. Content area now full width (max 1400px). Inline ChampSearch with arrow keys, Enter to confirm, pre-fills from URL params.",
    },
    {
      date: "31 May 2026",
      title: "laner.gg: Compact radar, range bars merged into abilities tab",
      content:
        "Radar chart shrunk to a compact pentagon strip with dual stat bars. Abilities tab restructured into 3 columns: your spells, range and cooldown bars, opponent spells. Everything visible side by side with no separate tab needed.",
    },
    {
      date: "16 May 2026",
      title:
        "laner.gg: Full champion data endpoint + matchup-aware item scoring",
      content:
        "Champions list endpoint now returns stats, spells and passive, enabling the comp analyser to use real spell data. Recommended build now adjusts based on the opponent's threat profile rather than just your champion's class.",
    },
    {
      date: "14 May 2026",
      title:
        "laner.gg: Route split, landing page, champion and player profiles",
      content:
        "Full route split into /, /matchup, /champion/:name and /summoner/:region/:name. Smart search bar routes to champion page, matchup or player profile based on input. Player profile uses Riot API for rank, recent matches and top champions.",
    },
    {
      date: "14 May 2026",
      title: "laner.gg: Live item scoring from Data Dragon",
      content:
        "Items tab rebuilt to fetch all items live from Riot Data Dragon. Scoring engine analyses opponent ability text, base stats and class tags to surface counter items. Recommended build adjusts to the specific matchup.",
    },
    {
      date: "14 May 2026",
      title:
        "laner.gg: Passives displayed, item recommendations vs opposite laner",
      content:
        "Passive ability now shown above spells in the abilities tab for both champions. Item recommendations introduced with counter items scored against the opponent's kit.",
    },
    {
      date: "11 May 2026",
      title: "laner.gg: Renamed from ezleague, visual depth overhaul",
      content:
        "Project renamed to laner.gg. Visual improvements including champion header banners, card glows, ambient sidebar lighting and larger champion images throughout.",
    },
    {
      date: "07 May 2026",
      title: "laner.gg: Keyword matchup content engine, 29k entries generated",
      content:
        "Built a matchup content generator covering all 172x172 champion pairs. Generates trade verdicts, key threats, tips and power spikes from champion tag and ability keyword analysis.",
    },
    {
      date: "07 May 2026",
      title: "laner.gg: Radar chart, range visualiser, ability video hover",
      content:
        "Radar chart scoring damage, tankiness, mobility, control and survivability. Range and cooldown bar chart for side-by-side comparison. Ability video hover pulls clips from the Riot CDN on mouseover.",
    },
    {
      date: "07 May 2026",
      title: "laner.gg: Team comp view + dynamic champion slots",
      content:
        "Team composition view supporting up to 5v5. Dynamic champion slots allow adding and removing per side.",
    },
    {
      date: "05 May 2026",
      title: "laner.gg: First working prototype deployed",
      content:
        "First working prototype live. Champion and matchup API endpoints operational with full stat comparison logic. 172 champions seeded from Riot Data Dragon into PostgreSQL. Deployed to Netlify and Render.",
    },
    {
      date: "14 Feb 2026",
      title: "Valentines with C#",
      content: "Focusing on C# and Azure.",
    },
    {
      date: "26 Dec 2025",
      title: "Review",
      content:
        "Taking time with lawsofux.com to improve foundations of UX design.",
    },
    {
      date: "20 Dec 2025",
      title: "Winter Break",
      content: "Finished assignments, back to projects.",
    },
    {
      date: "4 Dec 2025",
      title: "ezstox: Better use of data and condensing code",
      content:
        "Improved organisation, removed clutter. Data handling improved including forcing LLM to ignore P/E valuations and analyst targets when working with ETFs.",
    },
    {
      date: "2 Dec 2025",
      title: "ezstox: Improved scraping and data context",
      content:
        "Added newspaper3k with jina.ai as backup. Success rate improved from 30% to 90%. P/E valuations, analyst targets and accurate multi-source data now showing via yFinance.",
    },
    {
      date: "2 Dec 2025",
      title: "ezstox: Split into easier-to-use menu",
      content:
        "Preventing overwhelming terminal scrolling. Investigating different scraping sources including Polygon.io.",
    },
    {
      date: "29 Oct 2025",
      title: "ezstox: Finding workarounds for article scraping",
      content:
        "Logging scraping failures and letting the LLM flag insufficient data. Using more fundamental data from OpenBB for analysis.",
    },
    {
      date: "27 Oct 2025",
      title: "ezstox: Prompt engineering + information tuning",
      content:
        "Testing different models, tokens, prompt negatives and positives. Fixed web scraping logic with JinaAI.",
    },
    {
      date: "15 Oct 2025",
      title: "ezstox: LLM advisor implementation",
      content:
        "Generic but functional. API and key working with OpenAI, needs prompt engineering.",
    },
    {
      date: "15 Oct 2025",
      title: "ezstox: Tracker generally working",
      content:
        "Using OpenBB for accurate stock prices, personal holdings and basic news source links.",
    },
    {
      date: "11 Oct 2025",
      title: "ezstox: Created ezstox",
      content: "Modular portfolio tracker with insights using OpenBB.",
    },
    {
      date: "15 Sep 2025",
      title: "Social media app backend",
      content: "Added functional password hashing and credential hashing.",
    },
    {
      date: "24 Aug 2025",
      title: "Tested and configured connections and POST/GET with Supabase",
      content:
        "Required intensive reading of React and Supabase documentation.",
    },
    {
      date: "27 Jul 2025",
      title: "Long-term",
      content:
        "Working on a social media application for niche craft communities.",
    },
  ];

  return (
    <div className="blog-container">
      <h3>Recent Updates</h3>
      <div className="blog-posts-wrapper">
        <div className="blog-posts-scroll">
          {posts.map((post, index) => (
            <div key={index} className="blog-post">
              <div className="post-date">{post.date}</div>
              <h4 className="post-title">{post.title}</h4>
              <p className="post-content">{post.content}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default BlogSection;
